import { TakeOverReleaseDialog } from '../../molecules/TakeOverReleaseDialog.jsx';
import { TakeOverRequestDialog } from '../../molecules/TakeOverRequestDialog.jsx';
import { useDataFileTakeoverState } from './useDataFileTakeoverState.js';

export const TakeOverDialog = () => {
  const {
    userRequestedBy,
    hasDataFileBeenFinished,
    isLockedByAnotherUser,
    hasBeenReleasedByTimeout,
    isSubmitting,
    handleRequestDataFile,
    handleReleaseDataFile,
    handleRejectReleaseDataFile,
    navigateToImportsList,
  } = useDataFileTakeoverState();

  if (isLockedByAnotherUser) {
    return (
      <TakeOverRequestDialog
        hasBeenReleasedByTimeout={hasBeenReleasedByTimeout}
        hasDataFileBeenFinished={hasDataFileBeenFinished}
        onClose={navigateToImportsList}
        onSubmit={handleRequestDataFile}
        isSubmitting={isSubmitting}
      />
    );
  }

  if (userRequestedBy) {
    return (
      <TakeOverReleaseDialog
        userRequestedBy={userRequestedBy}
        onClose={handleRejectReleaseDataFile}
        onSubmit={handleReleaseDataFile}
        isSubmitting={isSubmitting}
      />
    );
  }

  return null;
};
